import { Palette } from '../palette'
import { Scale } from '../scale'

export interface State {
  palette: Palette
}
export namespace State {
  export const INITIAL: Readonly<State> = {
    palette: Palette.from(Scale.ALL),
  }
}
